import React from "react";
import { FaTrash } from "react-icons/fa";
import AppModal from "./AppModal";

const DeleteModal = ({
  show,
  setShow,
  onConfirm,
  title = "Delete Item",
  message = "This action cannot be undone.",
  buttonText = "Yes Delete",
}) => {

  return (
    <AppModal
      show={show}
      setShow={setShow}
      title="Warning"
      size="modal-md"
      footer={
        <>
          <button
            className="btn btn-secondary"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={onConfirm}
          >
            {buttonText}
          </button>
        </>
      }
    >

      <div className="text-center">

        <div
          className="mx-auto mb-3 rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center"
          style={{
            width: "70px",
            height: "70px",
          }}
        >
          <FaTrash
            className="text-danger"
            size={28}
          />
        </div>

        <h5 className="fw-bold text-danger">
          {title}
        </h5>

        <p className="text-muted mb-0">
          {message}
        </p>

      </div>

    </AppModal>
  );
};

export default DeleteModal;